import { ComponentType } from 'react';
import classnames from 'classnames';

import responseResumeLinkButtonClick from '@hh.ru/analytics-js-events/build/xhh/employer/responses/resume_card/response_resume_link_button_click';
import { Link, HSpacing } from '@hh.ru/magritte-ui';
import { LabelFlameFilledSize16 } from '@hh.ru/magritte-ui/product';
import { SPALink } from '@hh.ru/redux-spa-middleware';

import { makeResumeHref } from 'src/components/ResumeCard/utils/makeResumeHref';
import translation from 'src/components/translation';
import { useFeatureEnabled } from 'src/hooks/useFeatureEnabled';
import { useSelector } from 'src/hooks/useSelector';
import type { ResumeCardData } from 'src/models/resumeCard';

import styles from './index.less';

const Features = {
    collectResumeViewDuration: 'collect_resume_view_duration',
};

const TrlKeys = {
    emptyTitle: 'resume.title.empty',
};

interface Props {
    isGifted: boolean;
    isResponse: boolean;
    isVisited: boolean;
    markAsVisited: () => void;
    markAsRead?: () => void;
    resume: ResumeCardData;
    vacancyId?: number;
}

const ResumeCardTitle: ComponentType<Props> = translation(
    ({ trls, resume, markAsVisited, markAsRead, isResponse, isGifted, isVisited, vacancyId }) => {
        const highlight = useSelector((state) => state.resumeSearchResult.queries?.highlight);
        const openInNewWindow = useSelector((state) => state.employerSearchSettings.openInNewWindow);

        const isMarked = resume?._attributes?.marked;
        const handleClick = () => {
            responseResumeLinkButtonClick({
                vacancyId,
                gifted: isGifted,
                resumeHash: resume._attributes.hash,
            });
            markAsVisited();
            markAsRead?.();
        };
        const collectResumeViewDurationFeature = useFeatureEnabled(Features.collectResumeViewDuration);

        const queryParams: Record<string, string | undefined> = {};
        if (collectResumeViewDurationFeature && resume.searchRid) {
            queryParams.searchRid = resume.searchRid;
        }

        return (
            <h3 className={styles.title}>
                <Link
                    typography="title-5-semibold"
                    enableVisited
                    Element={SPALink}
                    to={makeResumeHref({
                        id: resume._attributes.id,
                        hash: resume._attributes.hash,
                        simhash: resume._attributes.sim_hash,
                        topicId: resume.topicId,
                        highlight,
                        isResponse,
                        vacancyId,
                    })}
                    additionalQueryParams={queryParams}
                    target={openInNewWindow || openInNewWindow === undefined ? '_blank' : '_self'}
                    rel="nofollow"
                    onClick={handleClick}
                    data-qa={classnames('serp-item__title', {
                        'serp-item__title_marked': isMarked,
                    })}
                    inline
                >
                    <span className={classnames({ [styles.linkVisited]: isVisited })}>
                        {/* тайтла может не быть, если это незавершенное дублированное резюме*/}
                        {resume.title[0]?.string ?? <span>{trls[TrlKeys.emptyTitle]}</span>}
                    </span>
                </Link>
                {isMarked && (
                    <span className={styles.icon}>
                        <HSpacing default={8} />
                        <LabelFlameFilledSize16 initialColor="negative" />
                    </span>
                )}
            </h3>
        );
    }
);

export default ResumeCardTitle;
